import React from 'react';
import styled from 'styled-components';

/**
 * 옵션 추가 시 CountInputBtn 옆에 있는 가격 Component
 */
const OptionPriceBtnBlock = styled.div`
    float: right;
    margin-top: 10px;
`;

const OptionPriceBtn = ({ value, closeBtnHandler }) => {

    // console.log("value : " + value);

    if (value === 0) {
        return <OptionPriceBtnBlock>loading</OptionPriceBtnBlock>;
    }
    return (
        <OptionPriceBtnBlock>
            <p style={{ float: 'left' }}>
                <span className="font-mont">{Number((value * 1).toFixed(1)).toLocaleString()}</span>원
            </p>
        </OptionPriceBtnBlock>
    );
};

export default OptionPriceBtn;
